import { Grid, Icon, Tooltip } from 'gu-ui-kit'
import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export const HeadCell = ({ alias, tooltip = true }) => {
  const { t } = useTranslation()

  return (
    <Grid
      direction={'row'}
      alignItems={'center'}
      justifyContent={'start'}
      gap={8}
    >
      {t(`referral::referral_clients.table.head.${alias}.label`)}
      {tooltip && (
        <Tooltip
          title={t(`referral::referral_clients.table.head.${alias}.tooltip`)}
          textAlign={'center'}
        >
          <Icon name={'information'} size={'sm'} color={'Interface-Eighth'} />
        </Tooltip>
      )}
    </Grid>
  )
}

HeadCell.propTypes = {
  alias: PropTypes.string,
  tooltip: PropTypes.bool,
}
